// src/services/blogService.js
import { getWithExpiry, setWithExpiry } from '../models/storageModel';

// Function to load blog posts from localStorage or default data
export const loadBlogPosts = async () => {
    try {
        // Try to get posts from localStorage first
        const savedPosts = getWithExpiry('blogPosts');
        if (savedPosts) {
            return savedPosts;
        }

        // If no saved posts, load from the default data file
        const defaultPosts = await import('../data/blogPosts.json');
        return defaultPosts.default;
    } catch (error) {
        console.error('Error loading blog posts:', error);
        return [];
    }
};

// Function to save blog posts to localStorage
export const saveBlogPosts = (posts) => {
    setWithExpiry('blogPosts', posts);
};

// Function to add a new blog post
export const addBlogPost = async (newPost) => {
    try {
        const posts = await loadBlogPosts();

        // Generate a new ID (highest ID + 1)
        const maxId = posts.length > 0 ? Math.max(...posts.map(post => post.id)) : 0;
        const postWithId = {
            ...newPost,
            id: maxId + 1,
            date: new Date().toLocaleDateString('ru-RU')
        };

        const updatedPosts = [...posts, postWithId];
        saveBlogPosts(updatedPosts);
        return updatedPosts;
    } catch (error) {
        console.error('Error adding blog post:', error);
        return null;
    }
};

// Function to update an existing blog post
export const updateBlogPost = async (updatedPost) => {
    try {
        const posts = await loadBlogPosts();
        const updatedPosts = posts.map(post =>
            post.id === updatedPost.id ? updatedPost : post
        );

        saveBlogPosts(updatedPosts);
        return updatedPosts;
    } catch (error) {
        console.error('Error updating blog post:', error);
        return null;
    }
};

// Function to delete a blog post
export const deleteBlogPost = async (postId) => {
    try {
        const posts = await loadBlogPosts();
        const updatedPosts = posts.filter(post => post.id !== postId);

        saveBlogPosts(updatedPosts);
        return updatedPosts;
    } catch (error) {
        console.error('Error deleting blog post:', error);
        return null;
    }
};

// Function to get Telegram user
export const getTelegramUser = () => {
    if (window.Telegram && window.Telegram.WebApp) {
        return window.Telegram.WebApp.initDataUnsafe?.user;
    }
    return null;
};

// Function to check if user is admin
export const isAdminUser = () => {
    const user = getTelegramUser();
    // Check if user ID matches the admin ID (replace with your admin's Telegram ID)
    return user && user.id === 123456789; // Replace with actual admin ID
};

// Function to send data to Telegram
export const sendDataToTelegram = (data) => {
    if (window.Telegram && window.Telegram.WebApp) {
        window.Telegram.WebApp.sendData(JSON.stringify(data));
        return true;
    }
    return false;
};